import { ChainCallProtocolTabs } from 'modules/chains/components/ChainCallProtocolTabs';
import { ChainSubtypeTabs } from 'modules/chains/components/ChainSubtypeTabs';
import { ChainTypeTabs } from 'modules/chains/components/ChainTypeTabs';
import { GroupSelector } from 'modules/chains/components/GroupSelector';

import { useChainSelectorsStyles } from './useChainSelectorsStyles';

export const ChainSelectors = () => {
  const { classes } = useChainSelectorsStyles();

  return (
    <div className={classes.root}>
      <ChainTypeTabs
        className={classes.tabs}
        classNameTab={classes.tab}
        classNameTabsInner={classes.tabsInner}
        classNameTabsWrapper={classes.tabsWrapper}
      />
      <ChainSubtypeTabs
        className={classes.tabs}
        classNameTab={classes.tab}
        classNameTabsInner={classes.tabsInner}
        classNameTabsWrapper={classes.tabsWrapper}
      />
      <GroupSelector
        className={classes.tabs}
        classNameTab={classes.tab}
        classNameTabsInner={classes.tabsInner}
        classNameTabsWrapper={classes.tabsWrapper}
      />
      <ChainCallProtocolTabs
        className={classes.tabs}
        classNameTab={classes.tab}
        classNameTabsInner={classes.tabsInner}
        classNameTabsWrapper={classes.tabsWrapper}
      />
    </div>
  );
};
